"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyInfoEdit = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const admin_context_1 = require("@src/components/pages/admin/admin-context");
const react_router_1 = require("react-router");
const CompanyInfoEditForm_1 = require("./CompanyInfoEditForm");
const CompanyInfoEdit = () => {
    const { companyInfo: company } = (0, admin_context_1.useAdminContextValue)();
    const history = (0, react_router_1.useHistory)();
    react_1.default.useEffect(() => {
        var _a;
        if ((_a = company === null || company === void 0 ? void 0 : company.companyPremiumSettings) === null || _a === void 0 ? void 0 : _a.hasPremiumProfileEnabled) {
            history.pushLocalized(`/firma/${company.companyUrl}`);
        }
    }, [company]);
    return (0, jsx_runtime_1.jsx)(CompanyInfoEditForm_1.CompanyInfoEditForm, {});
};
exports.CompanyInfoEdit = CompanyInfoEdit;
